// This file is auto-generated. Do not edit!

export default [
  {
    id: "0x72CCB97cbdC40f8fb7FFA42Ed93AE74923547200",
    version: 310,
    name: "wstETH v3",
    symbol: "dcp0xLRT",
    curator: "cp0x Mainnet curator",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    underlyingToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf00B548f1b69cB5EE559d891E03A196FB5101d4A",
    version: 310,
    name: "Gearbox WETH v3",
    symbol: "dWETHV3-cp0x",
    curator: "cp0x Mainnet curator",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    underlyingToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xF791Ecc5F2472637eac9DFe3f7894C0B32C32bDf",
    version: 310,
    name: "Re7 tBTC",
    symbol: "Re7tBTC",
    curator: "Re7 Labs",
    asset: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    underlyingToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0xC155444481854c60e7a29f4150373f479988F32D",
    version: 310,
    name: "USDC",
    symbol: "USDC",
    curator: "Invariant Group",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    underlyingToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF0795C47fA58d00f5F77F4D5c01F31eE891E21B4",
    version: 310,
    name: "Resolv USDC",
    symbol: "rUSDC",
    curator: "Tulipa",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    underlyingToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA9d17f6D3285208280a1Fd9B94479c62e0AABa64",
    version: 310,
    name: "wstETH v3",
    symbol: "kpkwstETH",
    curator: "kpk",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    underlyingToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x9396DCbf78fc526bb003665337C5E73b699571EF",
    version: 310,
    name: "WETH Market",
    symbol: "kpkWETH",
    curator: "kpk",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    underlyingToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x119f75D5AC5739Ae49ffC46117a20654793A9b18",
    version: 310,
    name: "EDGE UltraYield USDC",
    symbol: "edgeUSDC",
    curator: "Edge UltraYield",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    underlyingToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xb46edf298989F0F106EDD80E4ae8f59a13531dB4",
    version: 310,
    name: "EDGE UltraYield ETH",
    symbol: "edgeETH",
    curator: "Edge UltraYield",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    underlyingToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xd98e31C67c7C21f233C37c9AC9Ae656dcb0d5d25",
    version: 310,
    name: "Edge UltraYield ETH Prime",
    symbol: "primeETH",
    curator: "Edge UltraYield",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    underlyingToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x683FAf5BAFd88d4c383cCaf3d61C26AF2E164409",
    version: 310,
    name: "WBTC",
    symbol: "dWBTC-V3-0",
    curator: "Gami Labs",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    underlyingToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
] as const
